var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMexcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.529297,
    y: 0.5,
    width: 45,
    height: 45,
    fill: "url(#pattern0_146_128)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_146_128",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_146_128",
    transform: "scale(0.0294118)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_146_128",
    width: 34,
    height: 34,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAIqADAAQAAAABAAAAIgAAAAACeqFUAAADPUlEQVRYCe1WTUgbQRSeNLGkJjGK5kcjiXorNIKEHBQs9CCCB8WKChYshF7FS27eCoL14kUFCx48tKIEelIPggie1Fg8FGoQg1iliaaxzZ8xMZl+a4mu2dlkU6878JjZ9755883bN2+GELnJEZAjUFoEFBLhWuDeQAwQP+QzRKw9gWEIYoEEIZ8gaUjBJoWIvqmpadvlctmqq6vVu7u74dXV1Z+BQOAFw7OqpqbmAFgj5ujOzs4SMzMzoXA4/BzYBAMvWWVobGwM0Lx2fHxM6+vr9/O9WCwWXzQazUNT2tLSwkXRnI+X/I3dfd3Y2BA45hSTk5OJioqK2ZwzvV6/ND8/f80Cr6+vU4PB4M1hS+rLy8tdAwMDwu3xVrJarWE4tUNeORyOXzyTYNjX1xfVaDRvSyLBgRUKBc1mswKHfIXX66U6ne47SF+cnJzwTYJxKpWiSqUyUxIRhNGDMN8IvDEUw8PDV52dnUmGSaCam5u7MZlMS1LJvESY/wi8FFAg5DQWixVA3Juam5sjINJalAwS8MLv99/PlDBaXl6m/f39EpCU+nw+WllZGShIBKfkw9jYGDPzi63S1dVFV1ZWisFu7W63+wprvRcjY0VuxCV5YoCCwSA1Go0MC1tVVVV1BSLC2gIn+2I1g+1KqJ2YmKCjo6NCA0OztrZGkbjbD6KCYvRucHBQWrYxnPJVKO306OiIrxIdd3d3x5Do3L30r0mpGaLe8gx7e3u0p6cnT8v+TCQStKys7PZCVNpsttnp6WkHjpWUCzDHXbSvra0lh4eHBCeP4I4RxXEGkCDIy+zOzo6GmM3mH5FIhE35Edq2tjZ6eXlZ1MP5+Tmtq6s74N4OaZTygsz/xzg+Pk56e3uLTs1kMgRClVqt1oIccba3tyuLzioB0NDQQPBmIXi/kNZW8UI6NTWV3tzcnL3NC6fT+dFutw91dHRoUGg4hiUseQ/l/nk6/fAxtri4SE5PT8nIyMgdEBsnuBLI1tZWNhQKLXg8HtddguJmHMIL7DV6A37Vs7tZwoECRE0qlUqDBHjKN+MopuLx+AMdZwe5jFqt/pbDgsgNsL+TyeQX3NoLOb3cyxGQIyBH4DER+AtpmhKyRwnJOAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMexcIcon);
export default __webpack_public_path__ + "static/media/mexc-icon.9851b4090d0f58841f195e37e9881dfa.svg";
export { ForwardRef as ReactComponent };